import React from 'react';
import './FloatingTabBar.css';

const FloatingTabBar = ({ sections, activeSection, onTabClick }) => {
  const scrollToSection = (sectionId) => {
    const sectionElement = document.getElementById(sectionId);
    if (sectionElement) {
      // Adjust for fixed header height if you have one
      const headerOffset = 70; // Example offset, adjust to your header's height
      const elementPosition = sectionElement.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });

      if (onTabClick) {
        onTabClick(sectionId);
      }
    }
  };

  return (
    <nav className="floating-tab-bar">
      {sections.map((section) => (
        <button
          key={section.id}
          className={`tab-bar-item ${activeSection === section.id ? 'active' : ''}`}
          onClick={() => scrollToSection(section.id)}
          aria-label={`Go to ${section.label} section`}
        >
          {/* Render the icon component directly */}
          {section.icon && <span className="tab-icon">{section.icon}</span>}
          <span className="tab-label">{section.label}</span>
        </button>
      ))}
    </nav>
  );
};

export default FloatingTabBar;
